import config from '../../config/generated.json'

import isAppWhiteLabeled from './isAppWhiteLabeled'

export default function isAppAcceptingOnlyPreOrders(): boolean {
  return isAppWhiteLabeled() && !!config.ui.acceptPreOrdersOnly
}
